// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  GET_PHONE_INFO_HOST:
    'https://get-certificate-7hnz7cqujq-uc.a.run.app',
};
